import {
  axiosPut,
  axiosGet,
  axiosPost,
  axiosDelete
} from '@/utils/require'

// 联系我们 
export function shipcontactus (params) {
  return axiosPost(`/ship/website/shipcontactus`, params)
}


// WEBPACK FOOTER //
// ./src/api/collect.js